// GeocoderSlot.jsx — title-bar center slot toggling the map geocoder search bar (ticket 03 extraction).
//
// rerender-no-inline-components: JSX slot extracted to a proper component so React
// gets a stable component identity and doesn't remount on every parent render.

import React from 'react';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import SearchRounded from '@mui/icons-material/SearchRounded';
import GeocoderBar from '../../../mapEditor/GeocoderBar';

function GeocoderSlot({ showGeocoder, mapRef, onToggle }) {
    return (
        <>
            {showGeocoder && <Box sx={{ width: 260, flexShrink: 0 }}><GeocoderBar mapRef={mapRef} /></Box>}
            <Tooltip title={showGeocoder ? 'Close search' : 'Search location'}>
                <IconButton size="small" onClick={onToggle} aria-label="Search location" sx={{ color: showGeocoder ? 'primary.main' : 'text.secondary' }}>
                    <SearchRounded sx={{ fontSize: 18 }} />
                </IconButton>
            </Tooltip>
        </>
    );
}

export default GeocoderSlot;
